import * as React from "react"
import { useForm } from 'react-hook-form';
import parse from 'html-react-parser';
import moment from "moment";

import Arrow from "../components/Arrow"
import IconDownloadPDF from "../components/icons/IconDownloadPDF"

const LeadMagnet = ({ formId, title, text, formUrl }) => {

   const [isNormalStatus, setNormalStatus] = React.useState(true)

   const { register, handleSubmit } = useForm({
      mode: 'onSubmit',
      reValidateMode: 'onChange',
      defaultValues: {},
      resolver: undefined,
      context: undefined,
      criteriaMode: "all",
      shouldFocusError: true,
      shouldUnregister: false,
      shouldUseNativeValidation: true,
      delayError: undefined
   });

   const onSubmit = async (data, form) => {
      const requestOptions = {
           method: 'POST',
           mode: 'no-cors',
           referrerPolicy: 'no-referrer',
           headers: {
               'Content-Type': 'application/json',
               'Access-Control-Allow-Origin': '*',
               'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
           },
           body: JSON.stringify(data)
      };

      await fetch(formUrl, requestOptions).then(function(response) {
           if(response) {
               setNormalStatus(false)
               form.target.reset()
           }
           throw new Error('Network response was not ok.');
      }).catch(function(error) {
           console.log('There has been a problem with your fetch operation: ', error.message);
      });

   }


   return (
      <section className="lead-magnet" id="blockLeadMagnet">
         <div className={isNormalStatus ? "container mx-auto py-16 lg:py-24 opacity-100 overflow-visible w-full h-full" : "opacity-0 overflow-hidden w-0 h-0"}>
            <IconDownloadPDF w="60" h="80" />
            <div className="uppercase pb-4 mt-6">{parse(title)}</div>
            <p>{parse(text)}</p>
            <form className="pt-12" onSubmit={handleSubmit(onSubmit, this)}>
               <input
                  type="hidden"
                  value={moment().format("DD-MM-YYYY HH:mm:ss")}
                  {...register("_timestamp", {})}
               />
               <input
                  type="hidden"
                  value={typeof window !== 'undefined' ? window.location.href : ''}
                  {...register("_sentfrom", {})}
               />
               <div className="flex items-center">
                  <div className="form-group">
                     <label htmlFor="email">Email Adresse</label>
                     <input
                        type="email"
                        {...register("email", {required: true, pattern: /^\S+@\S+$/i})}
                     />
                  </div>
                  <button className="md:ml-24 text-white text-lg font-bold"><Arrow color="#fff"/> Checkliste anfordern</button>
               </div>
               <div className="form-group-checkbox mt-12">
                  <div className="input-wrapper">
                     <input
                        name="checkbox"
                        type="checkbox"
                        {...register("checkbox", {required: true})}
                     />
                  </div>
                  <div className="label-wrapper">
                     <label htmlFor="checkbox">
                        Ich habe die <a href="/datenschutzerklaerung" title="Rekord Fenster | Datenschutzrichtlinien" target="_blank" rel="noopener">Datenschutzrichtlinien</a> von REKORD gelesen und akzeptiert. *
                     </label>
                  </div>
               </div>
            </form>
         </div>
         <div className={isNormalStatus ? "opacity-0 overflow-hidden w-0 h-0" : "container mx-auto py-16 lg:py-24 opacity-100 overflow-visible w-full h-full"}>
            <h3 className="uppercase pb-4">
               Danke
               <span className="text-black"> dir</span>.
            </h3>
            <p>Die Checkliste wurde an deine Email-Adresse gesendet</p>
         </div>
      </section>
   )
}

export default LeadMagnet
